




// import React, { useState, useEffect } from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
// import './App.css';

// // Screens
// import Home from './screens/Home/Home';
// import ProductsPage from './screens/ProductsPage/ProductsPage';
// import Cart from './screens/Cart/Cart';
// import Login from './screens/Login/Login';
// import Checkout from './screens/Checkout/Checkout';
// import OrderConfirmation from './screens/OrderConfirmation/OrderConfirmation';
// import ContactUs from './components/Footer/ContactUs';
// import Faq from './components/Footer/Faq';
// import Blog from './components/Footer/Blog';
// import Newsroom from './components/Footer/Newsroom';
// import Compare from './screens/Compare/Compare';
// import Wishlist from './screens/Wishlist/Wishlist';
// import AboutUs from './components/Footer/AboutUs';
// import PrivacyPolicy from './components/Footer/PrivacyPolicy';
// import ShippingPolicy from './components/Footer/ShippingPolicy';
// import TermsOfUse from './components/Footer/TermsOfUse';
// import ProductDetailsPage from './components/ProductDetails/ProductDetailsPage';
// import ProfilePage from './screens/Profile/ProfilePage'; 
// import EditProfilePage from './screens/Profile/EditProfilePage';
// import OrdersPage from './screens/Orders/OrdersPage';

// // New Components Hub and Design Makers Hub screens
// import ComponentsHub from './screens/ComponentsHub/ComponentsHub';
// import DesignMakersHub from './screens/DesignMakersHub/DesignMakersHub';
// import ModelsScreen from './screens/DesignMakersHub/ModelsScreen';
// import ModelCategories from './screens/DesignMakersHub/ModelCategories';

// // Components
// import Header from './components/Header/Header';
// import Footer from './components/Footer/Footer';
// import FloatingActions from './components/FloatingActions/FloatingActions';
// import WelcomeModal from './components/Auth/WelcomeModal';

// // Services
// import { FirestoreService } from './firebase/firestoreService';

// // Layout component to apply appropriate classes based on route
// const MainContentLayout = ({ children }) => {
//   const location = useLocation();
  
//   // Determine the appropriate class based on the current route
//   const getMainContentClass = () => {
//     if (location.pathname === '/components-hub' || location.pathname.startsWith('/components-hub/')) {
//       return 'main-content components-hub';
//     } else if (location.pathname === '/design-makers-hub' || location.pathname.startsWith('/design-makers-hub/')) {
//       return 'main-content design-hub';
//     } else {
//       return 'main-content';
//     }
//   };
  
//   return (
//     <main className={getMainContentClass()}>
//       {children}
//     </main>
//   );
// };

// // Auth guard component
// const ProtectedRoute = ({ element, isLoggedIn }) => {
//   return isLoggedIn ? element : <Navigate to="/login" />;
// };

// function App() {
//   const [showWelcomeModal, setShowWelcomeModal] = useState(false);
//   const [userData, setUserData] = useState(null);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);

//   // Effect to check login status and display welcome modal if needed
//   useEffect(() => {
//     const checkLoginStatus = async () => {
//       try {
//         const authToken = localStorage.getItem('authToken');
//         const storedUserData = localStorage.getItem('userData');
        
//         if (authToken && storedUserData) {
//           // User is logged in
//           const parsedUserData = JSON.parse(storedUserData);
//           setUserData(parsedUserData);
//           setIsLoggedIn(true);
          
//           // Check if this is a new login session - use a session storage flag
//           const hasSeenWelcome = sessionStorage.getItem('hasSeenWelcome');
//           if (!hasSeenWelcome) {
//             // First time in this session, show welcome modal
//             setShowWelcomeModal(true);
//             sessionStorage.setItem('hasSeenWelcome', 'true');
//           }
          
//           // Sync with Firestore
//           if (parsedUserData.uid) {
//             try {
//               await FirestoreService.syncUserData(parsedUserData.uid);
//             } catch (syncError) {
//               console.error("Error syncing user data:", syncError);
//             }
//           }
//         } else {
//           // User is not logged in
//           setIsLoggedIn(false);
//           setUserData(null);
//         }
//       } catch (error) {
//         console.error("Error checking login status:", error);
//         setIsLoggedIn(false);
//         setUserData(null);
//       }
//     };
    
//     checkLoginStatus();
//   }, []);

//   // Listen for login events
//   useEffect(() => {
//     const handleLoginEvent = async (event) => {
//       if (event.detail && event.detail.userData) {
//         setUserData(event.detail.userData);
//         setIsLoggedIn(true);
//         setShowWelcomeModal(true);
        
//         // Sync with Firestore
//         if (event.detail.userData.uid) {
//           try {
//             await FirestoreService.syncUserData(event.detail.userData.uid);
//           } catch (syncError) {
//             console.error("Error syncing user data after login:", syncError);
//           }
//         }
//       }
//     };

//     window.addEventListener('userLoggedIn', handleLoginEvent);
    
//     return () => {
//       window.removeEventListener('userLoggedIn', handleLoginEvent);
//     };
//   }, []);

//   // Handle logout
//   const handleLogout = () => {
//     try {
//       localStorage.removeItem('authToken');
//       localStorage.removeItem('userData');
//       sessionStorage.removeItem('hasSeenWelcome');
//       setIsLoggedIn(false);
//       setUserData(null);
//       setShowWelcomeModal(false);
      
//       // Dispatch event for other components to react
//       window.dispatchEvent(new Event('userLoggedOut'));
//     } catch (error) {
//       console.error("Error during logout:", error);
//     }
//   };

//   return (
//     <Router>
//       <div className="app">
//         <Header isLoggedIn={isLoggedIn} userData={userData} />
        
//         {/* Welcome Modal */}
//         {showWelcomeModal && userData && (
//           <WelcomeModal 
//             userData={userData} 
//             onClose={() => setShowWelcomeModal(false)} 
//             onLogout={handleLogout}
//           />
//         )}
        
//         <MainContentLayout>
//           <Routes>
//             <Route path="/" element={<Home />} />
//             <Route path="/products" element={<ProductsPage />} />
//             <Route path="/cart" element={<Cart />} />
//             <Route 
//               path="/login" 
//               element={
//                 <Login 
//                   onLoginSuccess={(userData) => {
//                     setUserData(userData);
//                     setIsLoggedIn(true);
//                     setShowWelcomeModal(true);
//                   }}
//                 />
//               } 
//             />
//             <Route path="/checkout" element={<Checkout />} />
//             <Route path="/order-confirmation" element={<OrderConfirmation />} />
//             <Route path="/compare" element={<Compare />} />
//             <Route path="/wishlist" element={<Wishlist />} />
//             <Route path="/about-us" element={<AboutUs />} />
//             <Route path="/privacy-policy" element={<PrivacyPolicy />} />
//             <Route path="/shipping-policy" element={<ShippingPolicy />} />
//             <Route path="/terms-of-use" element={<TermsOfUse />} />
//             <Route path="/contact" element={<ContactUs />} />
//             <Route path="/faq" element={<Faq />} />
//             <Route path="/blog" element={<Blog />} />
//             <Route path="/newsroom" element={<Newsroom />} />
//             <Route path="/products/:productId" element={<ProductDetailsPage />} />
            
//             {/* New routes for Components Hub and Design Makers Hub */}
//             <Route path="/components-hub" element={<ComponentsHub />} />
//             <Route path="/design-makers-hub" element={<DesignMakersHub />} />
//             <Route path="/design-makers-hub/models" element={<ModelsScreen />} />
//             <Route path="/design-makers-hub/categories" element={<ModelCategories />} />
            
//             {/* Protected profile routes */}
//             <Route 
//               path="/profile" 
//               element={isLoggedIn ? <ProfilePage /> : <Navigate to="/login" state={{ from: '/profile' }} />} 
//             />

//             <Route 
//               path="/profile/edit" 
//               element={isLoggedIn ? <EditProfilePage /> : <Navigate to="/login" state={{ from: '/profile/edit' }} />} 
//             />
//             <Route 
//               path="/orders" 
//               element={isLoggedIn ? <OrdersPage /> : <Navigate to="/login" state={{ from: '/orders' }} />} 
//             />
            
//             <Route path="/search" element={<div>Search Page (To be implemented)</div>} />
            
//             {/* Fallback route for 404 */}
//             <Route path="*" element={<div>Page Not Found</div>} />
//           </Routes>
//         </MainContentLayout>
//         <Footer />
//         {/* Add FloatingActions to every page */}
//         <FloatingActions />
//       </div>
//     </Router>
//   );
// }

// export default App;







import React, { useState, useEffect, useRef, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { CookiesProvider, useCookies } from 'react-cookie';
import './App.css';

// Screens
import Home from './screens/Home/Home';
import ProductsPage from './screens/ProductsPage/ProductsPage';
import Cart from './screens/Cart/Cart';
import Login from './screens/Login/Login';
import Checkout from './screens/Checkout/Checkout';
import OrderConfirmation from './screens/OrderConfirmation/OrderConfirmation';
import ContactUs from './components/Footer/ContactUs';
import Faq from './components/Footer/Faq';
import Blog from './components/Footer/Blog';
import Newsroom from './components/Footer/Newsroom';
import Compare from './screens/Compare/Compare';
import Wishlist from './screens/Wishlist/Wishlist';
import AboutUs from './components/Footer/AboutUs';
import PrivacyPolicy from './components/Footer/PrivacyPolicy';
import ShippingPolicy from './components/Footer/ShippingPolicy';
import TermsOfUse from './components/Footer/TermsOfUse';
import ProductDetailsPage from './components/ProductDetails/ProductDetailsPage';
import ProfilePage from './screens/Profile/ProfilePage'; 
import EditProfilePage from './screens/Profile/EditProfilePage';
import OrdersPage from './screens/Orders/OrdersPage';

// New Components Hub, Design Makers Hub, and Demo Projects screens
import ComponentsHub from './screens/ComponentsHub/ComponentsHub';
import DesignMakersHub from './screens/DesignMakersHub/DesignMakersHub';
import ModelsScreen from './screens/DesignMakersHub/ModelsScreen';
import ModelCategories from './screens/DesignMakersHub/ModelCategories';
import DemoProjects from './screens/DemoProjects/DemoProjects';

// Components
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import FloatingActions from './components/FloatingActions/FloatingActions';
import WelcomeModal from './components/Auth/WelcomeModal';
import CookieConsent from './components/Cookies/CookieConsent';
import ScrollToTop from './components/utils/ScrollToTop';

// Services
import { FirestoreService } from './firebase/firestoreService';
import { trackUserAction } from './services/analyticsService';
import { auth, db } from './firebase/firebaseConfig';
import { getDoc, doc, setDoc, serverTimestamp } from 'firebase/firestore';

// Layout component to apply appropriate classes based on route
const MainContentLayout = ({ children }) => {
  const location = useLocation();
  
  // Determine the appropriate class based on the current route
  const getMainContentClass = () => {
    if (location.pathname === '/components-hub' || location.pathname.startsWith('/components-hub/')) {
      return 'main-content components-hub';
    } else if (location.pathname === '/design-makers-hub' || location.pathname.startsWith('/design-makers-hub/')) {
      return 'main-content design-hub';
    } else {
      return 'main-content';
    }
  };
  
  return (
    <main className={getMainContentClass()}>
      {children}
    </main>
  );
};

// Route tracking component to log page views
const RouteTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Track page view on route change
    trackUserAction('page_view', { 
      path: location.pathname,
      timestamp: new Date().toISOString()
    });
  }, [location.pathname]);
  
  return null;
};

function AppContent() {
  const [cookies, setCookie, removeCookie] = useCookies(['user_data', 'auth_token', 'preferences', 'consent']);
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  const [userData, setUserData] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showCookieConsent, setShowCookieConsent] = useState(false);
  const consentSyncTriggeredRef = useRef(false);

  // Effect to check cookie consent status
  useEffect(() => {
    // Check if user has already given consent (either true or false)
    // Only show consent banner if user has never interacted with it before
    const consentValue = cookies.consent;
    const hasConsentDecision = consentValue !== undefined && consentValue !== null && consentValue !== '';
    
    if (!hasConsentDecision) {
      setShowCookieConsent(true);
    } else {
      setShowCookieConsent(false);
    }
  }, [cookies.consent]);

  // Effect to check login status and display welcome modal if needed
  useEffect(() => {
    const checkLoginStatus = async () => {
      try {
        // First check cookies for authentication
        const cookieAuthToken = cookies.auth_token;
        const cookieUserData = cookies.user_data;
        
        // Fallback to localStorage if not in cookies (for backward compatibility)
        const localAuthToken = localStorage.getItem('authToken');
        const localUserData = localStorage.getItem('userData');
        
        if (cookieAuthToken && cookieUserData) {
          // User is logged in via cookies
          setUserData(cookieUserData);
          setIsLoggedIn(true);
          
          // Track login event silently in the background
          trackUserAction('user_session_restored_from_cookies');
          
          // Check if this is a new login session
          const hasSeenWelcome = sessionStorage.getItem('hasSeenWelcome');
          if (!hasSeenWelcome) {
            setShowWelcomeModal(true);
            sessionStorage.setItem('hasSeenWelcome', 'true');
          }
          
          // Sync with Firestore
          if (cookieUserData.uid) {
            try {
              await FirestoreService.syncUserData(cookieUserData.uid);
            } catch (syncError) {
              console.error("Error syncing user data:", syncError);
            }
          }
        } else if (localAuthToken && localUserData) {
          // Legacy login via localStorage - migrate to cookies
          const parsedUserData = JSON.parse(localUserData);
          
          // Only set cookies if user has given consent
          const hasAcceptedCookies = cookies.consent === 'true' || cookies.consent === true;
          if (hasAcceptedCookies) {
            setCookie('auth_token', localAuthToken, { path: '/', maxAge: 30 * 24 * 60 * 60 }); // 30 days
            setCookie('user_data', parsedUserData, { path: '/', maxAge: 30 * 24 * 60 * 60 }); // 30 days
          }
          
          setUserData(parsedUserData);
          setIsLoggedIn(true);
          
          // Track login migration event silently
          trackUserAction('user_session_migrated_from_localstorage');
          
          // Check if this is a new login session
          const hasSeenWelcome = sessionStorage.getItem('hasSeenWelcome');
          if (!hasSeenWelcome) {
            setShowWelcomeModal(true);
            sessionStorage.setItem('hasSeenWelcome', 'true');
          }
          
          // Sync with Firestore
          if (parsedUserData.uid) {
            try {
              await FirestoreService.syncUserData(parsedUserData.uid);
            } catch (syncError) {
              console.error("Error syncing user data:", syncError);
            }
          }
        } else {
          // User is not logged in
          setIsLoggedIn(false);
          setUserData(null);
        }
      } catch (error) {
        console.error("Error checking login status:", error);
        setIsLoggedIn(false);
        setUserData(null);
      }
    };
    
    checkLoginStatus();
  }, [cookies, setCookie]);

  // Listen for login events
  useEffect(() => {
    const handleLoginEvent = async (event) => {
      if (event.detail && event.detail.userData) {
        setUserData(event.detail.userData);
        setIsLoggedIn(true);
        setShowWelcomeModal(true);
        
        // Store user data in cookies if consent given
        const hasAcceptedCookies = cookies.consent === 'true' || cookies.consent === true;
        if (hasAcceptedCookies) {
          setCookie('auth_token', event.detail.authToken, { path: '/', maxAge: 30 * 24 * 60 * 60 }); // 30 days
          setCookie('user_data', event.detail.userData, { path: '/', maxAge: 30 * 24 * 60 * 60 }); // 30 days
        }
        
        // Still store in localStorage for backward compatibility
        localStorage.setItem('authToken', event.detail.authToken);
        localStorage.setItem('userData', JSON.stringify(event.detail.userData));
        
        // Track login event silently
        trackUserAction('user_logged_in', { 
          userId: event.detail.userData.uid,
          timestamp: new Date().toISOString()
        });
        
        // Sync with Firestore
        if (event.detail.userData.uid) {
          try {
            await FirestoreService.syncUserData(event.detail.userData.uid);
          } catch (syncError) {
            console.error("Error syncing user data after login:", syncError);
          }
        }
      }
    };

    window.addEventListener('userLoggedIn', handleLoginEvent);
    
    return () => {
      window.removeEventListener('userLoggedIn', handleLoginEvent);
    };
  }, [cookies.consent, setCookie]);

  // Handle logout
  const handleLogout = () => {
    try {
      // Get user ID before clearing cookies for tracking
      const userId = userData?.uid;
      
      // Clear cookies
      removeCookie('auth_token', { path: '/' });
      removeCookie('user_data', { path: '/' });
      
      // Clear localStorage for backward compatibility
      localStorage.removeItem('authToken');
      localStorage.removeItem('userData');
      sessionStorage.removeItem('hasSeenWelcome');
      
      // Update state
      setIsLoggedIn(false);
      setUserData(null);
      setShowWelcomeModal(false);
      consentSyncTriggeredRef.current = false;
      
      // Track logout event silently
      trackUserAction('user_logged_out', {
        userId: userId, // Use stored userId since we cleared cookies
        timestamp: new Date().toISOString()
      });
      
      // Dispatch event for other components to react
      window.dispatchEvent(new Event('userLoggedOut'));
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  // Handle cookie consent
  const handleCookieConsent = useCallback(async (accepted) => {
    // Gather current user context and cached profile data
    const storedUserDataRaw = localStorage.getItem('userData');
    let parsedUserData = null;
    if (storedUserDataRaw) {
      try {
        parsedUserData = JSON.parse(storedUserDataRaw);
      } catch (error) {
        console.error('Error parsing userData from localStorage:', error);
      }
    }

    if (!parsedUserData && userData) {
      parsedUserData = userData;
    }

    const currentUser = auth.currentUser;
    let deviceId = localStorage.getItem('device_id');
    if (!deviceId) {
      deviceId = 'device_' + Math.random().toString(36).substring(2, 15);
      localStorage.setItem('device_id', deviceId);
    }

    const preferenceDocId = currentUser?.uid || parsedUserData?.uid || deviceId;

    if (accepted) {
      // Set consent cookie
      setCookie('consent', 'true', { path: '/', maxAge: 365 * 24 * 60 * 60 }); // 1 year
      
      // Store consent acceptance in Firebase
      try {
        const consentData = {
          cookieConsent: true,
          consentDate: serverTimestamp(),
          userAgent: navigator.userAgent,
          deviceId: deviceId,
          timestamp: new Date().toISOString(),
          userId: currentUser?.uid || parsedUserData?.uid || null,
          email: parsedUserData?.email || currentUser?.email || '',
          phone: parsedUserData?.phone || '',
          deliveryAddress: parsedUserData?.deliveryAddress || '',
          name: parsedUserData?.name || currentUser?.displayName || ''
        };

        await setDoc(doc(db, 'user_preferences', preferenceDocId), consentData, { merge: true });

        console.log('✅ Cookie consent stored in Firebase user_preferences with user info:', {
          docId: preferenceDocId,
          email: consentData.email,
          phone: consentData.phone,
          deliveryAddress: consentData.deliveryAddress
        });
      } catch (error) {
        console.error('❌ Error storing consent in Firebase:', error);
        console.error('Error details:', {
          code: error.code,
          message: error.message,
          stack: error.stack
        });
      }
      
      // Fetch and store user data in cookies and Firebase if user is logged in
      if (isLoggedIn) {
        try {
          const authToken = localStorage.getItem('authToken');
          if (authToken) {
            setCookie('auth_token', authToken, { path: '/', maxAge: 30 * 24 * 60 * 60 }); // 30 days
          }
          
          if (currentUser) {
            console.log('Syncing user data for:', currentUser.uid);

            // Fetch fresh data from Firestore
            const userDoc = await getDoc(doc(db, 'users', currentUser.uid));

            if (userDoc.exists()) {
              const firestoreUserData = userDoc.data();

              // Update Firestore with cookie consent acceptance and timestamp
              await setDoc(doc(db, 'users', currentUser.uid), {
                cookieConsent: true,
                cookieConsentDate: serverTimestamp(),
                lastActive: serverTimestamp()
              }, { merge: true });

              // Prepare complete user data
              const completeUserData = {
                uid: currentUser.uid,
                email: firestoreUserData.email || currentUser.email || '',
                name: firestoreUserData.name || currentUser.displayName || '',
                phone: firestoreUserData.phone || '',
                deliveryAddress: firestoreUserData.deliveryAddress || '',
                points: firestoreUserData.points || 0,
                cookieConsent: true
              };

              // Store in cookies
              setCookie('user_data', JSON.stringify({
                email: completeUserData.email,
                phone: completeUserData.phone,
                deliveryAddress: completeUserData.deliveryAddress,
                name: completeUserData.name
              }), { path: '/', maxAge: 30 * 24 * 60 * 60 });

              // Update localStorage
              localStorage.setItem('userData', JSON.stringify(completeUserData));

              // Update state
              setUserData(completeUserData);

              // Ensure user_preferences has latest profile information
              await setDoc(doc(db, 'user_preferences', preferenceDocId), {
                email: completeUserData.email,
                phone: completeUserData.phone,
                deliveryAddress: completeUserData.deliveryAddress,
                name: completeUserData.name,
                userId: currentUser.uid,
                profileSyncedAt: serverTimestamp()
              }, { merge: true });

              // Store cart data in Firebase if exists
              const cartItems = localStorage.getItem('cartItems');
              if (cartItems) {
                try {
                  const parsedCart = JSON.parse(cartItems);
                  await setDoc(doc(db, 'carts', currentUser.uid), {
                    items: parsedCart,
                    updatedAt: serverTimestamp(),
                    userId: currentUser.uid
                  }, { merge: true });
                  console.log('✅ Cart data synced to Firebase');
                } catch (cartError) {
                  console.error('❌ Error syncing cart to Firebase:', cartError);
                }
              }

              // Store wishlist data in Firebase if exists
              const wishlistItems = localStorage.getItem('wishlistItems');
              if (wishlistItems) {
                try {
                  const parsedWishlist = JSON.parse(wishlistItems);
                  await setDoc(doc(db, 'wishlists', currentUser.uid), {
                    items: parsedWishlist,
                    updatedAt: serverTimestamp(),
                    userId: currentUser.uid
                  }, { merge: true });
                  console.log('✅ Wishlist data synced to Firebase');
                } catch (wishlistError) {
                  console.error('❌ Error syncing wishlist to Firebase:', wishlistError);
                }
              }

              // Store location preference in Firebase user_preferences
              const userLocation = localStorage.getItem('userLocation');
              if (userLocation) {
                try {
                  const parsedLocation = JSON.parse(userLocation);
                  await setDoc(doc(db, 'user_preferences', preferenceDocId), {
                    location: parsedLocation,
                    locationUpdatedAt: serverTimestamp()
                  }, { merge: true });
                  console.log('✅ Location preference synced to Firebase user_preferences');
                } catch (locationError) {
                  console.error('❌ Error syncing location to Firebase:', locationError);
                }
              }

              console.log('✅ All user data synced to Firebase:', {
                userId: currentUser.uid,
                email: completeUserData.email,
                phone: completeUserData.phone ? '***' + completeUserData.phone.slice(-4) : 'none',
                hasAddress: !!completeUserData.deliveryAddress,
                hasCart: !!cartItems,
                hasWishlist: !!wishlistItems,
                hasLocation: !!userLocation
              });
            } else if (storedUserDataRaw) {
              // User doc doesn't exist but we have localStorage data - create it
              await setDoc(doc(db, 'users', currentUser.uid), {
                uid: currentUser.uid,
                email: parsedUserData?.email || currentUser.email,
                name: parsedUserData?.name || currentUser.displayName,
                phone: parsedUserData?.phone || '',
                deliveryAddress: parsedUserData?.deliveryAddress || '',
                points: parsedUserData?.points || 0,
                cookieConsent: true,
                cookieConsentDate: serverTimestamp(),
                createdAt: serverTimestamp()
              });

              await setDoc(doc(db, 'user_preferences', preferenceDocId), {
                email: parsedUserData?.email || currentUser.email || '',
                phone: parsedUserData?.phone || '',
                deliveryAddress: parsedUserData?.deliveryAddress || '',
                name: parsedUserData?.name || currentUser.displayName || '',
                userId: currentUser.uid,
                profileSyncedAt: serverTimestamp()
              }, { merge: true });

              console.log('✅ User document created in Firebase with local storage data');
            }
          }
        } catch (error) {
          console.error('❌ Error syncing data to Firebase:', error);
          console.error('Error details:', {
            code: error.code,
            message: error.message
          });
        }
      } else {
        console.log('User not logged in - consent stored with device ID only');
      }

      // Track consent event
      trackUserAction('cookie_consent_accepted');
    } else {
      // Set minimal consent cookie to remember user rejected cookies
      setCookie('consent', 'false', { path: '/', maxAge: 365 * 24 * 60 * 60 }); // 1 year
      consentSyncTriggeredRef.current = false;

      // Store rejection in Firebase
      try {
        const rejectionData = {
          cookieConsent: false,
          consentDate: serverTimestamp(),
          userAgent: navigator.userAgent,
          deviceId: deviceId,
          timestamp: new Date().toISOString(),
          userId: currentUser?.uid || parsedUserData?.uid || null,
          email: parsedUserData?.email || currentUser?.email || '',
          phone: parsedUserData?.phone || '',
          deliveryAddress: parsedUserData?.deliveryAddress || '',
          name: parsedUserData?.name || currentUser?.displayName || ''
        };

        await setDoc(doc(db, 'user_preferences', preferenceDocId), rejectionData, { merge: true });

        console.log('✅ Cookie rejection stored in Firebase user_preferences:', preferenceDocId);
      } catch (error) {
        console.error('❌ Error storing rejection in Firebase:', error);
      }

      // Remove any existing cookies except the consent one
      removeCookie('auth_token', { path: '/' });
      removeCookie('user_data', { path: '/' });
      removeCookie('preferences', { path: '/' });

      // Track rejection event
      trackUserAction('cookie_consent_rejected');
    }

    setShowCookieConsent(false);
  }, [isLoggedIn, removeCookie, setCookie, setShowCookieConsent, setUserData, userData]);

  useEffect(() => {
    const consentAccepted = cookies.consent === 'true' || cookies.consent === true;

    if (!consentAccepted) {
      consentSyncTriggeredRef.current = false;
      return;
    }

    if (!userData || consentSyncTriggeredRef.current) {
      return;
    }

    consentSyncTriggeredRef.current = true;

    (async () => {
      try {
        await handleCookieConsent(true);
      } catch (error) {
        console.error('Error resyncing cookie consent with latest user data:', error);
        consentSyncTriggeredRef.current = false;
      }
    })();
  }, [cookies.consent, userData, handleCookieConsent]);

  return (
    <div className="app">
      <Header isLoggedIn={isLoggedIn} userData={userData} />
      
      {/* Scroll to top on route changes */}
      <ScrollToTop />
      
      {/* Route tracker for analytics */}
      <RouteTracker />
      
      {/* Welcome Modal */}
      {showWelcomeModal && userData && (
        <WelcomeModal 
          userData={userData} 
          onClose={() => {
            setShowWelcomeModal(false);
            trackUserAction('welcome_modal_closed');
          }} 
          onLogout={handleLogout}
        />
      )}
      
      {/* Cookie Consent Banner */}
      {showCookieConsent && (
        <CookieConsent 
          onAccept={() => handleCookieConsent(true)} 
          onReject={() => handleCookieConsent(false)}
          isLoggedIn={isLoggedIn}
        />
      )}
      
      <MainContentLayout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/cart" element={<Cart />} />
          <Route 
            path="/login" 
            element={
              <Login 
                onLoginSuccess={(userData, authToken) => {
                  setUserData(userData);
                  setIsLoggedIn(true);
                  setShowWelcomeModal(true);
                  
                  // The Login component should dispatch the userLoggedIn event
                }}
              />
            } 
          />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/order-confirmation" element={<OrderConfirmation />} />
          <Route path="/compare" element={<Compare />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/shipping-policy" element={<ShippingPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/newsroom" element={<Newsroom />} />
          <Route path="/products/:productId" element={<ProductDetailsPage />} />
          
          {/* New routes for Components Hub, Design Makers Hub, and Demo Projects */}
          <Route path="/components-hub" element={<ComponentsHub />} />
          <Route path="/design-makers-hub" element={<DesignMakersHub />} />
          <Route path="/design-makers-hub/models" element={<ModelsScreen />} />
          <Route path="/design-makers-hub/categories" element={<ModelCategories />} />
          <Route path="/demo-projects" element={<DemoProjects />} />
          
          {/* Protected profile routes */}
          <Route 
            path="/profile" 
            element={isLoggedIn ? <ProfilePage /> : <Navigate to="/login" state={{ from: '/profile' }} />} 
          />

          <Route 
            path="/profile/edit" 
            element={isLoggedIn ? <EditProfilePage /> : <Navigate to="/login" state={{ from: '/profile/edit' }} />} 
          />
          <Route 
            path="/orders" 
            element={isLoggedIn ? <OrdersPage /> : <Navigate to="/login" state={{ from: '/orders' }} />} 
          />
          
          <Route path="/search" element={<div>Search Page (To be implemented)</div>} />
          
          {/* Fallback route for 404 */}
          <Route path="*" element={<div>Page Not Found</div>} />
        </Routes>
      </MainContentLayout>
      <Footer />
      {/* Add FloatingActions to every page */}
      <FloatingActions />
    </div>
  );
}

function App() {
  return (
    <CookiesProvider>
      <Router>
        <AppContent />
      </Router>
    </CookiesProvider>
  );
}

export default App;
